import { useRef } from "react";
import { LiveCall } from "redux/slices/liveCalls.slice";
import {
  fetchCallHistoryLookup,
  CallHistoryRequest,
} from "../redux/thunks/fetchCallHistoryLookup";
import { useAppDispatch } from "../redux/hooks";

export const useHistoryLookups = () => {
  const dispatch = useAppDispatch();
  const fetchedCallUUIDs = useRef<Set<string>>(new Set());

  const fetchCallHistory = (call: LiveCall) => {
    const { callUUID, callDirection, callerIDNumber, destination } = call || {};
    
    if (
      !callUUID ||
      !callDirection ||
      !callerIDNumber ||
      !destination ||
      fetchedCallUUIDs.current.has(callUUID)
    ) {
      return;
    }

    const request: CallHistoryRequest = {
      callUUID,
      callDirection,
      callerIDNumber,
      destination,
    };

    fetchedCallUUIDs.current.add(callUUID);
    dispatch(fetchCallHistoryLookup(request));
  };

  return { fetchCallHistory };
};
